import { render, staticRenderFns } from "./TalkMemo.vue?vue&type=template&id=318a2d43&scoped=true"
import script from "./TalkMemo.vue?vue&type=script&lang=js"
export * from "./TalkMemo.vue?vue&type=script&lang=js"
import style0 from "./TalkMemo.vue?vue&type=style&index=0&id=318a2d43&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318a2d43",
  null
  
)

export default component.exports